import { createSignal, Show } from "solid-js";
import { Form, Spinner, Row, Col } from "solid-bootstrap";

export function InputOrderCodeForm(props) {
    const [submitting, setSubmitting] = createSignal(false);
    const [isError, setIsError] = createSignal(false);
    const [isRefreshing, setIsRefreshing] = createSignal(false);
    const onPaste = (event) => {
        setTimeout(() => {
            doOnSubmit();
        }, 100);
    };
    const refresh = () => {
        setTimeout(() => {
            window.location.reload();
        }, 100);
    };
    const doOnSubmit = () => {
        setIsError(false);
        setSubmitting(true);
        var orderCodeInput = document.getElementById("ordercode");
        if (!orderCodeInput) {
            setSubmitting(false);
            setIsError(false);
            console.log("ordercode element not found")
            return;
        }
        var orderCode = orderCodeInput.value;
        props.onSubmit(orderCode).then(() => {
            setSubmitting(false);
            setIsError(false);
            setIsRefreshing(true);
            refresh();
        }).catch((e) => {
            console.log(`error activating order: ${e}`);
            setSubmitting(false);
            setIsError(true);
        });
    };
    const onSubmit = (event) => {
        event.preventDefault();
        doOnSubmit();
    };
    return <Form id="order-code-form" onSubmit={onSubmit}>
        <InputOrderCodeFormGroup onPaste={onPaste} />
        <Form.Group>
            <Row>
                <Col xs={12} md={3}>
                    <Form.Control type="submit" value="Submit" />
                </Col>
            </Row>
        </Form.Group>
        <Show when={isRefreshing()}>
            <i>Success! Refreshing...</i>
        </Show>
        <Show when={submitting()}>
            <Spinner animation="border" />
        </Show>
        <Show when={isError()}>
            <i>Error</i>
        </Show>
    </Form>;
}

function InputOrderCodeFormGroup(props) {
    return <Form.Group controlId="ordercode">
        <Form.Label>Order code</Form.Label>
        <Row>
            <Col xs={12} md={3}>
                <Form.Control
                    type="text"
                    placeholder="Order code"
                    onPaste={props.onPaste} />
                <Form.Control.Feedback type="invalid">Order code required</Form.Control.Feedback>
            </Col>
        </Row>
    </Form.Group>;
}